import type { infer as zInfer } from "zod";
import { object, string } from "zod";

export const getTeamworkCommerceIntegration = {
  name: "getTeamworkCommerceIntegration" as const,
  input: object({}),
  output: object({
    teamworkCommerceIntegration: object({
      baseUrl: string(),
      apiKey: string(),
      greenReturnItemSku: string().optional(),
    }).optional(),
  }),
};

export type TeamworkCommerceIntegration = zInfer<
  typeof getTeamworkCommerceIntegration.output
>;
